<template>
    <div id="app">
        <Intro />
        <AnbieterLogos />
        <Angebote />
        <WieFunktioniertEs />
    </div>
</template>

<script>
  import Intro from '../components/Intro'
  import WieFunktioniertEs from '../components/WieFunktioniertEs'
  import AnbieterLogos from '../components/AnbieterLogos'
  import Angebote from '../components/Angebote'

  export default {
    components: {
      Intro,
      WieFunktioniertEs,
      AnbieterLogos,
      Angebote,
    }
  }
</script>
